<script setup>
import { ref, onMounted, watch } from 'vue';
import AppMenuItem from './AppMenuItem.vue';
//import router from '@/router';
import { AuthService } from '@/service/AuthService';
import { activeBranchId, userMenuTransform } from '@/core/js/common';
const menu = ref([]);
onMounted(() => {
    const userMenu = AuthService.getUserMenu();
    menu.value = userMenuTransform(userMenu);
});
watch(activeBranchId, () => {
    const userMenu = AuthService.getUserMenu();
    menu.value = userMenuTransform(userMenu);
});
function Logout() {
    AuthService.logout();
    //router.push('/login');
    window.location.href = '/login';
}
</script>
<template>
    <div class="flex flex-col h-full">
        <ul class="layout-menu flex-1">
            <template v-for="(item, i) in menu" :key="i">
                <app-menu-item v-if="!item.separator" :item="item" :index="i" />
                <li v-if="item.separator" class="menu-separator" />
            </template>
        </ul>

        <button type="button" class="layout-topbar-action text-red-600 flex items-center gap-2 mt-auto p-3 hover:bg-gray-100" @click="Logout">
            <i class="pi pi-power-off"></i>
            <span>Logout</span>
        </button>
    </div>
</template>
<style lang="scss" scoped></style>
